var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInternalStockTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.875,
    cy: 21,
    r: 21,
    fill: "#FF2D55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.419 16.5731C17.9974 15.9948 18.6711 15.5406 19.4217 15.223C20.1994 14.8942 21.0248 14.7274 21.875 14.7274C22.7252 14.7274 23.5506 14.8942 24.3283 15.223C25.0789 15.5406 25.7527 15.9948 26.331 16.5731C26.581 16.8231 26.8077 17.091 27.0102 17.3751V16.6993C27.0102 14.5323 25.2472 12.7693 23.0801 12.7693H18.205V11.0391L11.875 15.0276L16.4117 17.8861C16.6869 17.4079 17.0239 16.9682 17.419 16.5731Z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.875 27.0309L27.3383 24.1724C27.0631 24.6506 26.7261 25.0902 26.331 25.4854C25.7526 26.0637 25.0789 26.5179 24.3283 26.8353C23.5506 27.1643 22.7252 27.3311 21.875 27.3311C21.0248 27.3311 20.1994 27.1643 19.4217 26.8353C18.6711 26.5179 17.9973 26.0637 17.419 25.4854C17.169 25.2354 16.9423 24.9675 16.7398 24.6834V25.3592C16.7398 27.5262 18.5028 29.2892 20.6699 29.2892H25.5452V31.0194L31.875 27.0309Z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7463 21.0292C16.7463 23.8617 19.0425 26.158 21.875 26.158C24.7076 26.158 27.0038 23.8617 27.0038 21.0292C27.0038 18.1967 24.7076 15.9004 21.875 15.9004C19.0425 15.9004 16.7463 18.1967 16.7463 21.0292ZM19.9223 20.1956C19.9223 19.4709 20.4481 18.8617 21.4999 18.7143V18.0153H22.404V18.7014C22.8785 18.7463 23.3403 18.8681 23.7057 19.0733L23.2504 20.1698C22.808 19.9453 22.3912 19.8364 21.9999 19.8364C21.5576 19.8364 21.4164 19.9646 21.4164 20.1185C21.4164 20.6572 23.8981 20.2083 23.8981 21.8628C23.8981 22.5554 23.3979 23.1581 22.404 23.3313V24.0431H21.4999V23.3633C20.8586 23.3249 20.2366 23.1517 19.8518 22.9144L20.3392 21.8115C20.7625 22.0616 21.3267 22.222 21.8205 22.222C22.25 22.222 22.404 22.1321 22.404 21.9783C22.404 21.4138 19.9223 21.8692 19.9223 20.1956Z",
    fill: "#FF2D55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.875 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInternalStockTransfer);
export default __webpack_public_path__ + "static/media/ic_internal_stock_transfer.dbf5ebdb1c40bb043a69394d0fdea467.svg";
export { ForwardRef as ReactComponent };